import BasePanelLayout, { type PanelColorScheme } from "@/components/BasePanelLayout";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck } from "lucide-react";
import { superNav } from "@/config/navigation";
import { BRAND } from "@/lib/brand";

const superAdminColors: PanelColorScheme = {
  activeBg: "bg-violet-500/15",
  activeText: "text-violet-600",
  border: "border-violet-500/20",
  mobileActive: "border-violet-600 text-violet-600",
};

function SuperAdminSidebarHeader(collapsed: boolean) {
  return (
    <div className="flex items-center gap-2 overflow-hidden">
      <div className="h-8 w-8 rounded-lg bg-violet-600 flex items-center justify-center shrink-0">
        <ShieldCheck className="h-4 w-4 text-white" />
      </div>
      {!collapsed && (
        <div className="flex items-center gap-1.5">
          <span className="text-sm font-bold text-foreground whitespace-nowrap">{BRAND} Super</span>
          <Badge className="bg-violet-500/15 text-violet-600 border-violet-500/20 border text-[10px] px-1.5 py-0">
            SUPER
          </Badge>
        </div>
      )}
    </div>
  );
}

function SuperAdminMobileHeader() {
  return (
    <>
      <ShieldCheck className="h-5 w-5 text-violet-600" />
      <span className="font-bold text-sm">Superadmin</span>
    </>
  );
}

export default function SuperAdminLayout() {
  return (
    <BasePanelLayout
      navConfig={superNav}
      colorScheme={superAdminColors}
      sidebarHeader={SuperAdminSidebarHeader}
      mobileHeader={<SuperAdminMobileHeader />}
      darkBg="hsl(260 20% 8%)"
      lightBg="hsl(260 30% 97%)"
    />
  );
}
